import { render, staticRenderFns } from "./jaPrivacy.vue?vue&type=template&id=2715d682&scoped=true&"
import script from "./jaPrivacy.vue?vue&type=script&lang=js&"
export * from "./jaPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./jaPrivacy.vue?vue&type=style&index=0&id=2715d682&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2715d682",
  null
  
)

export default component.exports